import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const TemplatePageContainer = lazy(() =>
    import(/* webpackChunkName: "template" */ '@template/ui/TemplatePage').then(m => ({ default: m.TemplatePage })),
);
const EditEntryTypePageContainer = lazy(() =>
    import(/* webpackChunkName: "template" */ '@template/ui/EditEntryTypePage').then(m => ({
        default: m.EditEntryTypePage,
    })),
);
const EditBlockPageContainer = lazy(() =>
    import(/* webpackChunkName: "template" */ '@template/ui/EditBlockPage').then(m => ({ default: m.EditBlockPage })),
);

export const templateLocations: Location[] = [
    {
        url: '/template',
        Component: TemplatePageContainer,
    },
    {
        url: '/template/entry-type/:entryTypeId/version/:version',
        Component: EditEntryTypePageContainer,
    },
    {
        url: '/template/block/:blockId/version/:version',
        Component: EditBlockPageContainer,
    },
];
